import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output,ElementRef} from '@angular/core';
import {CommonService} from '../../common.service';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../api.service";
import {PerformanceService} from '../../case-practice-performance/performanceService';
import {ClashService} from '../../case-practice-clash/ClashService';


declare var $ :any;

@Component({
  selector: 'app-case-practice-stage-end',
  templateUrl: './case-practice-stage-end.component.html',
  styleUrls: ['./case-practice-stage-end.component.css']
})
export class CasePracticeStageEndComponent implements OnInit , AfterViewInit {
  @Output() onExit = new EventEmitter<any>(); //回传关闭事件
  @Output() onContinue = new EventEmitter<any>(); //回传继续事件
  @Output() onReport = new EventEmitter<any>(); //回传继续事件
  @Input() simulationName: string;// 情景模拟名称
  @Input() step: number;  //步骤
  // @Input() yelp: string;  //导师点评
  @Input() resultLevel: number; //单元结果等级
  @Input() exerciseId: number; //练习id
  @Input() stageDocument:any;//静态阶段文案
  // @Input() paperContent: string; //二级结果文案

  yelp: string;  //导师点评
  isShowFireworks: boolean=true; //一级结果页显示控制
  isShowReportLv: boolean=false;//二级结果页显示控制
  learningPointContent: any; //学习要点
  paperContent: string;//二级结果文案
  clickAble: boolean = false; //按钮点击判断
  confirmBtnFlag: boolean = true; //查看变革结果按钮兼容参数
  isShowLetter: boolean = true;
  assetsRoute: string = "../../../assets";

  constructor(
    private commonService: CommonService,
    private el: ElementRef,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private performanceService: PerformanceService,
    private clashService: ClashService) {}


  ngOnInit() {
    console.log(this.step)
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    if(this.simulationName=="performance"){
      this.setStageEndDocWithLevelAndStep(this.resultLevel,this.step);
    }else if(this.simulationName=="clash"){
      this.resultLevel = 4;
    }

  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor': 'transparent'
    });

    this.enableClickPreview('img','click');
  }

  //根据等级、阶段设置结果页反馈
  setStageEndDocWithLevelAndStep(level,step){
    level = level ==0? level : level-1;
   this.yelp = this.stageDocument['step'+step]['summaries'][level];
   this.learningPointContent = this.stageDocument['step'+step]['learningPointContent'];
  }


  // 显示学习要点页面
  learningPointAct(act){
    if(act=='in'){
      $('.learning-point-wrap').fadeIn(200);
    }else if(act=='out'){
      $('.learning-point-wrap').fadeOut(200);
    }
  }

  //获取当前阶段的导师反馈
  getTutorFeedback(){
    // this.isShowFireworks = false;
    // this.isShowReportLv = true;
    this.performanceService.getTutorFeedback(this.exerciseId,this.step+1).subscribe((result)=>{
      console.log(this.exerciseId);
      this.resultLevel = result.level;
      // this.setResultContent(this.resultLevel);
      this.isShowFireworks = false;
      this.isShowReportLv = true;
    });
  }

  //指定标签禁止事件
  enableClickPreview(target,event){
    let allITarget=  this.el.nativeElement.querySelectorAll(target);

    allITarget.forEach( v=>{
      v.addEventListener(event,function(e){
        e.preventDefault();
      });
    })
  }

  //按钮点击事件
  btnAct(act){
    switch(act){
      case 'exit':
        this.onExit.emit();
        this.isShowLetter = false;
        break;
      // 关闭
      case 'close':
        console.log("休息一下")
        let that = this;
        if(!that.clickAble){
          that.clickAble = true;
          that.confirmBtnFlag = false;
          that.onExit.emit();
          setTimeout(()=>{
            that.clickAble = false;
          },1000);
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(1,'isPractice' +'Complete')
        }else{
          return false;
        }

        break;
      // 继续
      case 'continue':
        this.onContinue.emit();
        break;
      // 进入二级页面
      case 'final':
        this.getTutorFeedback();
        break;
     // 查看报告
      case 'report':
        this.onReport.emit(true);
        const exerciseMetaId=$('#exerciseMetaId').val()
        this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
          console.log(result)
        })
        console.log("情景模拟做完！！");
        this.sendPostData();
        console.log(exerciseMetaId)
        this.commonService.sendPostMessage(2,'isPractice' +'Complete')
        break;
    }
  }

  sendPostData(){
    //向LMS平台传递进度数据
    if(localStorage.getItem("source_env") === "LMS_SCORM"){
      this.apiService.getUserQueryLearningProgress(Number(localStorage.getItem('learningPathMetaId'))).subscribe(res=>{
        this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',res[0].progressList[0].progress,"data");
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-stage-end/case-practice-stage-end.component.ts